
import { 
  Home, 
  CreditCard, 
  Search, 
  Syringe, 
  ShoppingBag, 
  MapPin, 
  Smartphone, 
  Calendar, 
  Wallet, 
  Gift, 
  Brain,
  FileText,
  BarChart3,
  Video,
  Users,
  Settings,
  TrendingUp,
  HelpCircle,
  BookOpen,
  Briefcase,
  Mail,
  XCircle,
  RotateCcw,
  Loader,
  Gem,
  Smile,
  MessageSquare,
  CreditCard as CreditCardAlt,
  Building,
  Shield,
  Package,
  UserCheck,
  Clipboard,
  DollarSign,
  PieChart,
  Lock,
  RefreshCw,
  Bot,
  Megaphone,
  CheckCircle,
  Play,
  FileCheck,
  Layers,
  Target,
  Wrench,
  ClipboardList,
  BarChart,
  Receipt
} from 'lucide-react';
import { SitemapSection } from '@/types/sitemap';

export const sitemapSections: SitemapSection[] = [
  {
    title: "For Patients",
    emoji: "👩‍🎤",
    description: "Patient-facing pages for discovering and booking treatments",
    category: "patients",
    items: [
      {
        title: "Home",
        href: "/",
        status: "live",
        description: "Smile, skin, and wellness under one roof",
        icon: Home
      },
      {
        title: "Membership",
        href: "/membership",
        status: "live",
        description: "Replace dental insurance with self-care credits",
        icon: CreditCard
      },
      {
        title: "Take the Quiz",
        href: "/quiz",
        status: "live",
        description: "Discover your glow path in 30 seconds",
        icon: Search
      },
      {
        title: "Treatments",
        href: "/treatments",
        status: "live",
        description: "Browse all JUV services and offerings",
        icon: Syringe
      },
      {
        title: "Shop",
        href: "/shop",
        status: "dev",
        description: "Purchase treatments, packages, and skincare",
        icon: ShoppingBag
      },
      {
        title: "Shop Packages",
        href: "/shop/packages",
        status: "dev",
        description: "Curated bundles for popular treatment combos",
        icon: Package
      },
      {
        title: "Shop by Concerns",
        href: "/shop/concerns",
        status: "dev",
        description: "Shop by skin concern or aesthetic goal",
        icon: Search
      },
      {
        title: "Product Storefront",
        href: "/shop/products",
        status: "dev",
        description: "Shop take-home kits, skincare, and more",
        icon: ShoppingBag
      },
      {
        title: "Locations",
        href: "/locations",
        status: "live",
        description: "Explore JUV studios near you",
        icon: MapPin
      },
      {
        title: "Glow App Dashboard",
        href: "/app",
        status: "live",
        description: "Manage credits, bookings, and rewards",
        icon: Smartphone
      },
      {
        title: "Book Now",
        href: "/locations#book",
        status: "live",
        description: "Schedule same-day appointments",
        icon: Calendar
      },
      {
        title: "App Wallet",
        href: "/app/wallet",
        status: "dev",
        description: "Manage payment methods and billing",
        icon: Wallet
      },
      {
        title: "App Credits",
        href: "/app/credits",
        status: "dev",
        description: "View, redeem, and stack credits",
        icon: CreditCardAlt
      },
      {
        title: "App Rewards",
        href: "/app/rewards",
        status: "dev",
        description: "Unlock bonuses as you glow",
        icon: Gift
      },
      {
        title: "App Concierge",
        href: "/app/concierge",
        status: "dev",
        description: "Chat with JUV experts for personalized advice",
        icon: MessageSquare
      },
      {
        title: "Referral Hub",
        href: "/referral",
        status: "dev",
        description: "Refer friends, earn bonus credits",
        icon: RefreshCw
      },
      {
        title: "SMS Consent",
        href: "/legal/sms",
        status: "live",
        description: "Required opt-in for SMS communication",
        icon: MessageSquare
      },
      {
        title: "Search Results",
        href: "/search",
        status: "coming-soon",
        description: "Dynamic result filtering for search bar",
        icon: Search
      },
      {
        title: "Webinars / Events",
        href: "/events",
        status: "dev",
        description: "On-demand or live partner/patient events",
        icon: Play
      },
      {
        title: "AI Concierge Preview",
        href: "/ai",
        status: "coming-soon",
        description: "Show how JUV's AI assistant helps users",
        icon: Bot
      }
    ]
  },
  {
    title: "For Dental Providers",
    emoji: "🦷",
    description: "Resources for dental practices looking to partner with JUV",
    category: "partners",
    items: [
      {
        title: "Partner Overview",
        href: "/partner",
        status: "live",
        description: "Add medspa services to your dental office",
        icon: Brain
      },
      {
        title: "Apply to Partner",
        href: "/partner/apply",
        status: "live",
        description: "Submit your practice for partnership review",
        icon: FileText
      },
      {
        title: "Case Studies",
        href: "/partner/case-studies",
        status: "dev",
        description: "Proven success stories from partner locations",
        icon: BarChart3
      },
      {
        title: "Book a Demo",
        href: "/partner/demo",
        status: "dev",
        description: "Talk to our expansion team",
        icon: Video
      }
    ]
  },
  {
    title: "Internal Staff Portal",
    emoji: "🧑‍💻",
    description: "Internal tools and dashboards for JUV team members",
    category: "staff",
    items: [
      {
        title: "Staff Dashboard",
        href: "/staff",
        status: "dev",
        description: "Internal overview and analytics",
        icon: BarChart3
      },
      {
        title: "Enhanced Dashboard",
        href: "/staff/dashboard/enhanced",
        status: "dev",
        description: "Advanced analytics and insights",
        icon: PieChart
      },
      {
        title: "Patient Management",
        href: "/staff/patients",
        status: "dev",
        description: "Search and manage member accounts",
        icon: Users
      },
      {
        title: "Appointments",
        href: "/staff/appointments",
        status: "dev",
        description: "Track bookings across locations",
        icon: Calendar
      },
      {
        title: "Credits Management",
        href: "/staff/credits",
        status: "dev",
        description: "View and adjust member credits",
        icon: CreditCard
      },
      {
        title: "Payment Processing",
        href: "/staff/payments",
        status: "dev",
        description: "Process payments and refunds",
        icon: DollarSign
      },
      {
        title: "Reports",
        href: "/staff/reports",
        status: "dev",
        description: "Monitor practice performance metrics",
        icon: TrendingUp
      },
      {
        title: "Treatment Catalog",
        href: "/staff/treatments",
        status: "dev",
        description: "Manage services, pricing, and availability",
        icon: Settings
      },
      {
        title: "Staff Settings",
        href: "/staff/settings",
        status: "dev",
        description: "Configure roles, permissions, and integrations",
        icon: Lock
      }
    ]
  },
  {
    title: "Admin / Developer Tools",
    emoji: "🧠",
    description: "Internal administration and development tools",
    category: "admin",
    items: [
      {
        title: "Admin CMS Panel",
        href: "/admin",
        status: "dev",
        description: "Internal CMS for managing treatments, users",
        icon: Settings
      },
      {
        title: "User Roles",
        href: "/admin/users",
        status: "coming-soon",
        description: "Role-based access system",
        icon: Users
      },
      {
        title: "Announcements Manager",
        href: "/admin/alerts",
        status: "coming-soon",
        description: "Post system-wide notices or updates",
        icon: Megaphone
      },
      {
        title: "Route Validator",
        href: "/admin/routes",
        status: "dev",
        description: "Developer tool to QA all links & states",
        icon: CheckCircle
      }
    ]
  },
  {
    title: "Operations: Kits, SOPs & Playbooks",
    emoji: "📦",
    description: "Operations tools, standard procedures, and training resources",
    category: "operations",
    items: [
      {
        title: "Launch Kit",
        href: "/kits/launch",
        status: "live",
        description: "Tools to launch a new JUV partner office",
        icon: Package
      },
      {
        title: "Daily Workflow SOPs",
        href: "/sops/daily",
        status: "dev",
        description: "Day-to-day checklists for staff",
        icon: ClipboardList
      },
      {
        title: "Onboarding SOP",
        href: "/sops/onboarding",
        status: "dev",
        description: "Training flow for new JUV team members",
        icon: UserCheck
      },
      {
        title: "Marketing Kit",
        href: "/kits/marketing",
        status: "dev",
        description: "Graphics, ads, and referral templates",
        icon: Target
      },
      {
        title: "System Setup Guide",
        href: "/kits/setup",
        status: "coming-soon",
        description: "GHL, Airtable, Memberstack setup",
        icon: Wrench
      },
      {
        title: "Treatment Menu Builder",
        href: "/kits/menu",
        status: "dev",
        description: "Modular Smile/Skin/Wellness menu generator",
        icon: Layers
      },
      {
        title: "Reporting Dashboard",
        href: "/staff/reports",
        status: "dev",
        description: "Metrics on bookings, revenue, patients",
        icon: BarChart
      },
      {
        title: "Billing & Credits SOP",
        href: "/sops/credits",
        status: "coming-soon",
        description: "Protocols for credit application and refunds",
        icon: Receipt
      }
    ]
  },
  {
    title: "Functional / Utility Routes",
    emoji: "⚙️",
    description: "Core system functionality and utility pages",
    category: "utilities",
    items: [
      {
        title: "Redirect Logic",
        href: "/redirect",
        status: "live",
        description: "Handles dynamic redirects from quizzes, emails, etc.",
        icon: RotateCcw
      },
      {
        title: "Confirmation Page",
        href: "/confirmation",
        status: "live",
        description: "Post-booking, quiz, or payment",
        icon: CheckCircle
      },
      {
        title: "Loading Screen",
        href: "/loading",
        status: "live",
        description: "In-app transition screen",
        icon: Loader
      },
      {
        title: "404 Page",
        href: "/404",
        status: "live",
        description: "Custom branded error page",
        icon: XCircle
      },
      {
        title: "Sitemap",
        href: "/sitemap",
        status: "live",
        description: "Complete site navigation map",
        icon: MapPin
      }
    ]
  },
  {
    title: "Sub-Brands",
    emoji: "🪞",
    description: "Specialized JUV brand offerings",
    category: "treatments",
    items: [
      {
        title: "Bespoke Veneers",
        href: "/bespoke",
        status: "live",
        description: "Luxury smile design by Dr. Parth",
        icon: Gem
      },
      {
        title: "Full Arch Implants",
        href: "/full-arch",
        status: "live",
        description: "Life-changing implant solutions",
        icon: Smile
      },
      {
        title: "Premium Veneers",
        href: "/veneers",
        status: "dev",
        description: "Custom veneer treatments",
        icon: Smile
      }
    ]
  },
  {
    title: "Platform & Support Pages",
    emoji: "🧠",
    description: "Core informational and support pages",
    category: "platform",
    items: [
      {
        title: "About JUV",
        href: "/about",
        status: "dev",
        description: "Meet our mission and team",
        icon: Users
      },
      {
        title: "FAQ",
        href: "/faqs",
        status: "live",
        description: "Answers to common questions",
        icon: HelpCircle
      },
      {
        title: "Blog",
        href: "/blog",
        status: "dev",
        description: "Education, stories, and results",
        icon: BookOpen
      },
      {
        title: "Careers",
        href: "/careers",
        status: "dev",
        description: "Join the JUV team",
        icon: Briefcase
      },
      {
        title: "Contact",
        href: "/contact",
        status: "live",
        description: "Get in touch with us",
        icon: Mail
      },
      {
        title: "Terms of Service",
        href: "/terms",
        status: "live",
        description: "Legal terms and conditions",
        icon: Clipboard
      },
      {
        title: "Privacy Policy",
        href: "/privacy",
        status: "live",
        description: "How we protect your data",
        icon: Shield
      }
    ]
  }
];
